'use strict';
import {module} from '../app';

module.directive('isSwiped', ['$ionicPopover', function ($ionicPopover) {
    return {
      restrict: 'A',
      link: function (scope, el, attrs) {
        scope.$watch(function () {
          let style = el.children('.item-content')[0].style[0];
          if (style == null)
            return null;
          return style.indexOf('transform') >= 0;
        }, function (val) {
          scope.$eval(attrs.isSwiped + '=' + val);
        });
      }
    };
  }]);



// WEBPACK FOOTER //
// ./src/scripts/directives/isSwiped.js